import type {Account} from '@pocketbuy/outdoor-business-types';
export function filterAccounts(accounts:Account[],search:string,role:string):Account[]{
  const term=search.trim().toLowerCase();
  const digits=term.replace(/\D/g,'');
  return accounts.filter(account=>(!role||account.roles.some(value=>value===role))&&(!term||
    account.displayName.toLowerCase().includes(term)||account.accountCode.toLowerCase().includes(term)||
    (digits.length>0&&/^[\d\s+()-]+$/.test(term)&&(account.phone??'').replace(/\D/g,'').includes(digits))));
}
